import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/Users/raphael.benitte/projects/edikit/website/src/components/DocLayout.js"

export default ({components, ...props}) => <MDXTag name="wrapper" Layout={DefaultLayout} layoutProps={props} components={components}>

<MDXTag name="h1" components={components} props={{"id":"installation"}}><MDXTag name="a" components={components} parentName="h1" props={{"ariaHidden":"true","href":"#installation"}}><MDXTag name="span" components={components} parentName="a" props={{"className":"icon icon-link"}}></MDXTag></MDXTag>{`Installation`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="strong" components={components} parentName="p">{`edikit`}</MDXTag>{` is available as a single npm package.`}</MDXTag>
<MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre">{`yarn add edikit
`}</MDXTag></MDXTag></MDXTag>

export const _frontmatter = {};

  